// The latest store is a compound of everything that makes up the
// latest store
import api from './api';
import storage from './storage';
import utils from './utils';
import business from './business';

const latestStore = {
  ...api,
  ...storage,
  ...utils,
  ...business
};


export default latestStore;
